import classnames from 'classnames';

import styles from './index.css';

export interface TransitionProp {
    className?: string;
    active?: boolean;
}

const Transition: React.FC<TransitionProp> = ({ className, active }) => {
    return (
        <div className={classnames(styles.transition, active && styles.active, className)}>
            Loading...
        </div>
    );
};

export default Transition;
